import React, { useState, useEffect } from 'react'; 
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Spinner, Modal} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit,faTrashAlt,faUser, faArrowRight ,faTools ,faPlus } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx'; 
import Header from '../Header';

const Userlist = () => {
  const [users, setUsers] = useState([]);  
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 
  const [deleteError, setDeleteError] = useState(null);  
  const [successMessage, setSuccessMessage] = useState(null);  
  const [editingUser, setEditingUser] = useState(null); 
  const [assigningManager, setAssigningManager] = useState(null);   
  const [managers, setManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showReminder, setShowReminder] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    address: '',
    source: '',
  });

  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false); 
  const [showAssignManagerModal, setShowAssignManagerModal] = useState(false); 
  const [isAssigning, setisAssigning] = useState(false);
  // const role = localStorage.getItem('role');
  // const navigate = useNavigate();

  useEffect(() => {
    const successMessageFromStorage = localStorage.getItem('successMessage');
  
    if (successMessageFromStorage) {
      setSuccessMessage(successMessageFromStorage);
      localStorage.removeItem('successMessage');
    }

    const fetchData = async () => {
      try {
        const userResponse = await fetch('https://apiaksharaconnect.aksharafinalytics.in/users');
        const userData = await userResponse.json();
        setUsers(userData.user || []);
        //console.log(userData);

        const updatedUsers = userData.user.map(user => {
          if (user.renewal_date ) {
            const today = new Date();
            const renewalDate = new Date(user.renewal_date);      

            // Ensure the renewal date is valid
            if (isNaN(renewalDate)) {
              console.error('Invalid renewal date for user:', user);
              return user;  // Skip invalid renewal date
            }

            const timeDifference = renewalDate - today;            
            const daysDifference = timeDifference / (1000 * 3600 * 24); // Convert ms to days

            // Check if renewal is within the next 5 days and if user has a balance due
            user.showReminder = daysDifference <= 5 && daysDifference > 0 ;            
          }
          return user;
        });

        // Update users with their reminder status
        setUsers(updatedUsers || []);

        // const plansResponse = await fetch('https://apiaksharaconnect.aksharafinalytics.in/plans');
        // const plansData = await plansResponse.json();
        // setPlans(plansData || []); 
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData(); 
  }, []);

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(users);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "users");

    XLSX.writeFile(wb, "Transactions_List.xlsx");
  };

  const deleteUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this user?");
    if (!confirmDelete) return;

    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/user_del/${userId}`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        throw new Error('Failed to delete user');
      }
      setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
      setDeleteError(null);  
      setSuccessMessage('User deleted successfully!');  
    } catch (error) {
      setDeleteError('Failed to delete the user. Please try again later.');  
      setSuccessMessage(null);  
    }
  };

  

  const handleEdit = (user) => {
    setSelectedPlan(user.plan);
    setEditingUser(user); 
    setFormData({
      id: user.id || '',
      name: user.company || '',
      email: user.email || '',
      phone: user.phone || '',
      address: user.address || '',
      source: user.source || '',
    });
    setShowEditModal(true); 
  };

 const handleFormChange = (e) => {
  const { name, value, files } = e.target;
  
  if (name === "pic" && files.length > 0) {
    setFormData(prevData => ({
      ...prevData,
      pic: files[0],  // Store the file object
    }));
  } else {
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  }
};


const handleSubmit = async (e) => {
  e.preventDefault();

  const formPayload = new FormData();
  formPayload.append('name', formData.name || '');
  formPayload.append('email', formData.email || '');
  formPayload.append('phone', formData.phone || '');
  formPayload.append('address', formData.address || '');
  formPayload.append('source', formData.source || '');

  if (formData.pic) {
    formPayload.append('pic', formData.pic);
  }


  try {
    const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/user_upd/${editingUser.id}`, {
      method: 'POST',
      body: formPayload,
    });

    if (!response.ok) {
      throw new Error('Failed to update user');
    }

    const updatedUsersList = users.map(user =>
      user.id === editingUser.id ? { ...user, ...formData } : user
    );

    setUsers(updatedUsersList);
    setSuccessMessage('User updated successfully!');
    setEditingUser(null);
    setFormData({});
    setShowEditModal(false);

    

  } catch (error) {
    console.error('Error updating user:', error);
    setError('Failed to update user. Please try again later.');
  }
};



  const validateForm = () => {
    return formData.name && formData.email && formData.phone && formData.amount;
  };


  useEffect(() => {
    const fetchManagers = async () => {
      try {
        const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/managers');
        if (!response.ok) {
          throw new Error('Failed to fetch managers');
        }
        const result = await response.json();
        // console.log(result); 
        setManagers(result.manager);  
      } catch (error) {
        setError(error.message);
      }
    };
  
    fetchManagers(); // Fetch managers when the component mounts
  }, []);

  const handleAssignManager = (userId) => {
    setAssigningManager(userId); 
    setShowAssignManagerModal(true); 
  };

  const handleManagerSelection = (e) => {
    setAssigningManager(e.target.value);
  };

  const submitManagerAssignment = async () => {
    if (!assigningManager || !selectedManager) {
      alert('Please select a manager');
      return;
    }
    setisAssigning(true);
    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/assign/${assigningManager}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({   
          mgr_id: selectedManager
        })
      });
      
      if (!response.ok) {
        throw new Error('Failed to assign manager');
      }
      
      setSuccessMessage('Manager assigned successfully!');
      setUsers((prevUsers) => 
        prevUsers.map((user) =>
          user.id === assigningManager ? { ...user, mgr_id: selectedManager } : user
        )
      );
      setShowAssignManagerModal(false);
    } catch (error) {
      setError('Failed to assign manager');
    }finally {
      setisAssigning(false); // Stop spinner
    }
  };

  const handleRenwal = async (userId, actionType) => {
    try {
      // Ensure userId and actionType are valid
      if (!userId || !actionType) {
        console.error('Invalid userId or actionType');
        return;
      }
  
      // Construct the URL correctly
      const url = `https://apiaksharaconnect.aksharafinalytics.in/testmail/${userId}/${actionType}`;
  
      // Send GET request to the API (instead of POST)
      const response = await fetch(url, {
        method: 'GET',  // Change to GET since the API route expects a GET request
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      // Handle response errors
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response:", errorData);
        throw new Error(`Network response was not ok. Status: ${response.status}`);
      }
  
      const data = await response.json();
  
      // Handle success
      setSuccessMessage(`${actionType} Remainder has been sent successfully!`);
    } catch (error) {
      console.error('Error occurred:', error);
     //setErrorMessage('Something went wrong. Please try again.');
    }
  }; 

  const formatDateForApi = (dateValue) => {
    if (!dateValue) return '';

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return '';

    return date.toISOString().slice(0, 10);
  };

  // Autodebit handler
  const handleAutodebit = async (userId) => {
    try {
      setLoading(true); 
      setError("");
      setDeleteError("");
      setSuccessMessage("");

      const userDetailsResponse = await fetch(
        `https://apiaksharaconnect.aksharafinalytics.in/userdetails/${userId}`
      );

      if (!userDetailsResponse.ok) {
        throw new Error("Failed to fetch user details for autodebit");
      }

      const userDetailsData = await userDetailsResponse.json();
      const userDetails = userDetailsData.userdetails || [];
      const selectedDetail = userDetails[0] || {};

      const payload = {
        id: userId,
        start_date: formatDateForApi(selectedDetail.start_date || selectedDetail.dor),
        end_date: formatDateForApi(selectedDetail.end_date || selectedDetail.renewal_date),
        amount: Number(selectedDetail.amount || selectedDetail.total_amount || selectedDetail.due || 0),
      };
      //console.log("Autodebit Payload:", payload);

      const response = await fetch(
        `https://apiaksharaconnect.aksharafinalytics.in/autodebit`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          body: new URLSearchParams({
            id: String(payload.id || ''),
            start_date: payload.start_date || '',
            end_date: payload.end_date || '',
            amount: String(payload.amount || 0),
          }).toString(),
        }
      );

      const data = await response.json();
     //console.log("API Response:", data);

    if (data.status === "success") {
        setSuccessMessage("Mandate registration initiated. Email sent successfully.");
      } else {
        setError("Mandate registration initiated, but email sending failed.");
      }

    } catch (err) {
      console.error(err);
      setDeleteError("Something went wrong. Please try again.");
    }

    setLoading(false);  // Stop loading after response
  };

  
  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="shadow mx-1 px-3 bg-light rounded-3">
        <div className="d-flex align-items-center justify-content-between p-3 mt-3">
          <div className="d-flex">
            <h4 className="mb-0 me-3">User Management</h4>
            <button className="btn btn-primary" onClick={() => navigate('/User')}>
              Add User
            </button>
          </div>
          
                  
          <div>
            <button className="btn btn-success" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        {deleteError && <div className="alert alert-danger">{deleteError}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}

        {/* Modal for Assigning Manager */}
        {showAssignManagerModal && (
          <Modal show={showAssignManagerModal} onHide={() => setShowAssignManagerModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Assign Manager</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
            <Form.Group controlId="mgr_id">
              <Form.Label>Select Manager</Form.Label>
              <Form.Control as="select" value={selectedManager || ''} onChange={e => setSelectedManager(e.target.value)}>
                <option value="">Select Manager</option>
                {managers.map(manager => (
                  <option key={manager.id} value={manager.id}>{manager.name}</option>
                  ))}
              </Form.Control>
            </Form.Group>              
            {/* <Button variant="primary" className='mt-2' onClick={submitManagerAssignment}>Assign Manager</Button> */}
            <Button variant="primary" className='mt-2' onClick={submitManagerAssignment} disabled={isAssigning}>
                          {isAssigning ? (
                            <>
                              <Spinner  as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
                              Assigning...
                            </>
                          ) : (
                            "Assign Manager"
                          )}
                        </Button>
            </Form>
          </Modal.Body>
        </Modal>
        )}

        {/* Edit Modal */}
        {showEditModal && (


          <div className="modal fade show" style={{ display: 'block' }} aria-labelledby="editModalLabel" aria-hidden="false">
          <div className="modal-dialog modal-lg modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="editModalLabel">Edit User</h5>
                <button  type="button"  className="btn-close" onClick={() => setShowEditModal(false)}  aria-label="Close" ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3 row">
                    <div className="col-6">
                      <label className="form-label">Company Name</label>
                      <input type="text" className="form-control" name="name" value={formData.name || ''} onChange={handleFormChange} />
                    </div>

                    <div className="col-6">
                      <label className="form-label">Email</label>
                      <input type="email" className="form-control" name="email" value={formData.email || ''} onChange={handleFormChange} />
                    </div>
                  </div>
        
                  <div className="mb-3 row">
                    <div className="col-6">
                      <label className="form-label">Phone</label>
                      <input type="text" className="form-control" name="phone" value={formData.phone || ''} onChange={handleFormChange} />
                    </div>

                    <div className="col-6">
                      <label className="form-label">Address</label>
                      <input type="text" className="form-control" name="address" value={formData.address || ''} onChange={handleFormChange} />
                    </div>
                  </div>
        
                  <div className="mb-3 row">
                    <div className="col-6">
                      <label className="form-label">Source</label>
                      <input type="text" className="form-control" name="source" value={formData.source || ''} onChange={handleFormChange} />
                    </div>

                     <div className="col-6">
                      <label className="form-label">Upload Picture</label>
                      <input type="file"className="form-control" name="pic" accept="image/*" onChange={handleFormChange}/>
                    </div>                    
                  </div>
                  
                  <div className="modal-footer d-flex justify-content-center">
                    <button type="submit" className="btn btn-primary" >Update User </button>
                    <button type="button" className="btn btn-secondary ms-2"  onClick={() => setShowEditModal(false)}> Cancel</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        
        )}

        <div className="card mt-3">
          <div className="card-header">User List</div>
          <div className="card-body">
          <table className="table table-striped">
              <thead>
                <tr>
                  <th>S.no</th>
                  <th>User</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Source</th>
                  <th>Lead By</th>
                  {/* <th>Email Reminder</th> */}
                  <th>Manage</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users?.length > 0 ? (
                  users.map((user, index) => (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>
                        <a href={`/userinfo/${user.id}`} className="text-decoration-none">
                          {user.company || 'N/A'}
                        </a>
                      </td>
                      <td>{user.email || 'N/A'}</td>
                      <td>{user.phone || 'N/A'}</td>
                      <td>{user.source || 'N/A'}</td>
                      <td>{user.leadby || 'N/A'}</td>
                      {/* <td>
                      {user.showReminder  ? (
                          <button className="btn btn-primary p-1 m-1" onClick={() => handleRenwal(user.id, 'Renwal')} title="Renwal">
                            Renwal
                          </button>
                        ) : (
                          ' '
                        )}
                        {user.due > 0 ? (
                          <button className="btn btn-secondary p-1 m-1"onClick={() => handleRenwal(user.id, 'Payment')} title="Payment">
                            Payment
                          </button>
                          ) : (
                            ' '
                          )}
                          
                      </td> */}
                      <td>
                        <button className="btn btn-info ms-2 p-1 m-1" onClick={() => handleAssignManager(user.id)} disabled={user.mgr_id != null} title="Assign Manager">
                          <FontAwesomeIcon icon={faUser}  />
                          <FontAwesomeIcon icon={faArrowRight}  /> 
                        </button>

                        <a className="btn btn-success ms-2 p-1 m-1 text-decoration-none" href={`/UserAddServices/${user.id}`} title='Add Another Service'>
                          <FontAwesomeIcon icon={faTools }  />&nbsp;
                          <FontAwesomeIcon icon={faPlus}  /> 
                        </a>

                        <a  className="btn btn-secondary ms-2 p-1 m-1 text-decoration-none" onClick={() => !loading && handleAutodebit(user.id)} title="Auto Debit" style={{ pointerEvents: loading ? "none" : "auto", opacity: loading ? 0.7 : 1 }}>
                          {loading ? "Processing..." : "Auto Debit"}
                        </a>

                        
                      </td>
                      <td>
                        <button className="btn btn-warning p-1 m-1" onClick={() => handleEdit(user)} disabled={user.mgr_id != null} title='Edit'>
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button className="btn btn-danger ms-2 p-1 m-1" onClick={() => deleteUser(user.id)} disabled={user.mgr_id != null} title='Delete'>
                          <FontAwesomeIcon icon={faTrashAlt } />
                        </button>                        
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className='text-center'>No users available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Userlist;
